import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import Careers from "./pages/Careers";
import JobDetail from "./pages/JobDetail";
import CareersAdmin from "./pages/CareersAdmin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/:code" element={<JobDetail />} />
          <Route path="/careers-admin" element={<CareersAdmin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
